export default {
	timestampToTimeWithDefault(timestamp, defaultValue = '--') {
		if (timestamp) {
			return this.timestampToTime(timestamp);
		}
		return defaultValue;
	},
	// 时间戳转换成年-月-日-时-分-秒格式
	timestampToTime(timestamp) {
		var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
		var Y = date.getFullYear() + '-';
		var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
		var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
		var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
		var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
		return Y + M + D + h + m + s;
	},
	// 时间戳转换成年-月-日-时-分-秒格式
	timestampToTime13(timestamp) {
		var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
		var Y = date.getFullYear() + '-';
		var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
		var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
		var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
		var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
		return Y + M + D + h + m + s;
	},

	// 时间戳转换成时-分-秒格式
	timestampToTimeHMS(second) {
		const days = Math.floor(second / 86400);
		const hours = Math.floor((second % 86400) / 3600);
		const minutes = Math.floor(((second % 86400) % 3600) / 60);
		const seconds = Math.floor(((second % 86400) % 3600) % 60);
		return (hours == 0 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds);
	},
	// 时间戳转换成天-时-分-秒格式
	formatDuring(second) {
		const days = Math.floor(second / 86400);
		const hours = Math.floor((second % 86400) / 3600);
		const minutes = Math.floor(((second % 86400) % 3600) / 60);
		const seconds = Math.floor(((second % 86400) % 3600) % 60);
		// const forMatDate = { days: days, hours: hours, minutes: minutes,seconds: seconds};
		return days + '天' + hours + '时' + minutes + '分' + seconds + '秒';
	},

	//将中国标准时间转成年-月-日格式
	formatDate(date) {
		var date = new Date(date);
		var y = date.getFullYear();
		var m = date.getMonth() + 1;
		m = m < 10 ? '0' + m : m;
		var d = date.getDate();
		d = d < 10 ? ('0' + d) : d;
		return y + '-' + m + '-' + d;
	},

	//计算两个时间相差天数
	datedifference(sDate1, sDate2) {    //sDate1和sDate2是yyyy-mm-dd格式
		let dateSpan,
			tempDate,
			iDays;
		sDate1 = Date.parse(sDate1);
		sDate2 = Date.parse(sDate2);
		dateSpan = sDate2 - sDate1;
		dateSpan = Math.abs(dateSpan);
		iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
		return iDays;
	},

	//00:00时分格式转换为int分钟数值
	makeToMinute(time) {
		const str = time;
		const arr = str.split(':');
		const minute = parseInt(arr[0] * 60) + parseInt(arr[1]);
		return minute;
	},

	//将秒数转换为时分秒格式，小于十补零
	secondToDate(result) {
		var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
		var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
		var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
		return result = m + ':' + s;
		// return result = h + ":" + m + ":" + s;
	},

	//将秒数转换为时分秒格式
	formatSeconds(value) {
		var theTime = parseInt(value);// 秒
		var middle = 0;// 分
		var hour = 0;// 小时
		if (theTime > 60) {
			middle = parseInt(theTime / 60);
			theTime = parseInt(theTime % 60);
			if (middle > 60) {
				hour = parseInt(middle / 60);
				middle = parseInt(middle % 60);
			}
		}
		// var result = ""+parseInt(theTime)+":";
		var result = '' + parseInt(theTime) + '';
		if (middle > 0) {
			result = '' + parseInt(middle) + ':' + result;
		}
		if (hour > 0) {
			result = '' + parseInt(hour) + ':' + result;
		}
		return result;
	},

	phoneHide(value) {
		// 显示手机号码中间4位*号[telphone-133****1234]
		if (value !== undefined) {
			let start = value.substring(0, 3),
				end = value.substring(7, 11);
			return start + '****' + end;
		}
	},

	calcPrice(m, float = true) {
		// 金额换算
		if (!parseInt(m)) {
			return '0.00';
		}
		let num = Math.round((m / 100) * 100) / 100;
		return float ? num.toFixed(2) : num;
	},

	//将数据为null，为空，为undefind做处理
	remarkText(text) {
		if (text === '' || text === null || text === undefined) {
			return '--';
		} else {
			return text;
		}
	},

	//城市格式化
	arrToStr(arr) {
		var result = '';
		if (arr && arr.length > 0) {
			arr.forEach(ele => {
				var ids = ele.join('_');
				result += ids + ',';
			});
			result = result.substring(0, result.length - 1);
		}

		return result;
	},
	strtoArr(arr) {
		var result = [];
		var ids = arr.split(',');
		ids.forEach(el => {
			var _id = el.split('_');
			result.push(_id);
		});
		return result;
	},

	//标签管理过滤
	findArray(dic, key, value) {
		for (let i = 0; i < dic.length; i++) {
			if (dic[i][key] == value) {
				return i;
			}
		}
		return -1;
	},
	//js保留几位小数（四舍五入）
	getFloat(num, n) {
		n = n ? parseInt(n) : 0;
		if (n <= 0) {
			return Math.round(num);
		}
		num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
		num = Number(num)
			.toFixed(n); //补足位数
		return num;
	},
	/**
	 * 防抖处理
	 * @param {当前组件的实例this} that
	 * @param {function回调函数} fn
	 * @param {number延迟时间} wait
	 */
	debounce(that, fn, wait) {
		clearTimeout(that.timeout);
		that.timeout = setTimeout(fn, wait);
	},
	deepClone (obj) {
    var objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (obj[key] && typeof obj[key] === "object") {
            objClone[key] = this.deepClone(obj[key]);
          } else {
            objClone[key] = obj[key];
          }
        }
      }
    }
    return objClone;
  },
  objAssign (obj1,obj2) {
    var objClone = this.deepClone(obj2);
    if (obj1 && typeof obj1 === "object") {
      for (let key in obj1) {
        if (obj1.hasOwnProperty(key)) {
          if (obj1[key] && typeof obj1[key] === "object") {
            objClone[key] = this.deepClone(obj1[key]);
          } else {
            if(!objClone[key]) {
              console.log(key,objClone[key],obj1[key])
              objClone[key] = obj1[key];
            }
          }
        }
      }
    }
    return objClone;
  }
};
